// Who may view / download / print a buyer Sales Order PDF (Buyer Sales Orders list and
// details pages). Everyone else gets a permission message instead of the PDF. This is a
// console-side gate only; the Excel exports are unchanged.
// Role names are matched ignoring case and spacing (one client's role is stored as
// "Centre<non-breaking space>Operation"). "City Lead" is accepted as City Head.
export const SO_DOC_ROLES = [
	'Centre Operation',
	'City Head',
	'City Lead',
	'MSM',
	'CXO Office',
	'INTERNAL',
];

export const SO_DOC_DENIED_MESSAGE =
	'You do not have permission to view this Sales Order. Allowed roles: Centre Operation, City Head, MSM, CXO Office.';

const normalizeRole = (role) => String(role ?? '').toLowerCase().replace(/\s+/g, '');

const SO_DOC_ROLE_KEYS = new Set(SO_DOC_ROLES.map(normalizeRole));

export const canTakeSalesOrderDoc = (userRolesDict) => {
	const roles = Object.values(userRolesDict ?? {});
	return roles.some((role) => SO_DOC_ROLE_KEYS.has(normalizeRole(role)));
};
